import TEREA_AMBER from '../../../../../assets/images/club/stories/switch-level3/milestone1/terea-amber.webp';
import TEREA_SIENNA from '../../../../../assets/images/club/stories/switch-level3/milestone1/terea-sienna.webp';
import TEREA_TURQUIZE from '../../../../../assets/images/club/stories/switch-level3/milestone1/terea-turquise.webp';
import {strCode} from '../../../../../consts/strCode';

const TEREA_CONFIG = [
    {
        id: 'TEREA_TURQUIZE',
        titleStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_TEREA_TURQUIZE,
        imageSrc: TEREA_TURQUIZE,
    },
    {
        id: 'TEREA_SIENNA',
        titleStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_TEREA_SIENNA,
        imageSrc: TEREA_SIENNA,
    },
    {
        id: 'TEREA_AMBER',
        titleStrCode: strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_TEREA_AMBER,
        imageSrc: TEREA_AMBER,
    },
];

export default TEREA_CONFIG;
